'use client';

import {
  Dialog,
  DialogActionButton,
  DialogCloseButton,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogSubTitle,
  DialogTitle,
} from '@pickleballinc/ui/components/ui/dialog-v2';

interface DeclineConfirmModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function DeclineConfirmModal({ open, onOpenChange, onConfirm }: DeclineConfirmModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='!max-w-[400px]'>
        <DialogHeader>
          <DialogTitle>Decline friend request?</DialogTitle>
          <DialogSubTitle>Are you sure you want to decline this friend request?</DialogSubTitle>
        </DialogHeader>
        <DialogFooter>
          <DialogCloseButton>Cancel</DialogCloseButton>
          <DialogActionButton onClick={onConfirm}>Confirm</DialogActionButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
